import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import times from 'helpers/times'
import moment from 'moment'

class NoActivityModal extends Component {
	constructor(props) {
		super(props)
		// On Mondays, they should be shown the previous week as it doesn't make sense to report no traffic for the coming week.
		if(moment().format('dddd') == 'Monday') {
			this.state = {
				startDate: moment.unix(times().lastWeek).format("D"),
				endDate: moment.unix(times().lastWeekEnd).format("D"),
				beginMonth: moment.unix(times().lastWeek).format("MMMM"),
				endMonth: moment.unix(times().lastWeekEnd).format("MMMM"),
				year: moment.unix(times().lastWeek).format("YYYY"),
			}
		}
		else {
			this.state = {
				startDate: moment.unix(times().thisWeek).format("D"),
				endDate: moment.unix(times().endThisWeek).format("D"),
				beginMonth: moment.unix(times().thisWeek).format("MMMM"),
				endMonth: moment.unix(times().endThisWeek).format("MMMM"),
				year: moment.unix(times().thisWeek).format("YYYY"),
			}
		}
		
	}

	

	render() {
		return (
			<div className="noActivity">
				<p>
					I have no Sales, Bust Outs, Lot Transfers, Starts, Closings or Traffic to report for the current
					week of{" "}
					{`${this.state.beginMonth} ${this.state.startDate} - ${this.state.endMonth} ${this.state.endDate}, ${this.state.year}`}
					.
				</p>
				<p>
					<span className="btn" onClick={this.props.notify}>
						CONFIRM
					</span>
				</p>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {

	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
		},
		dispatch
	)
}

export default connect(
	mapStateToProps,
	matchDispatchToProps
)(NoActivityModal)
